






















































































































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import SecureCodeModule from '@/store/modules/SecureCode';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import moment from 'moment';

@Component({
  components: {
    Table,
  },
})
export default class SecureCode extends Mixins(ErrorHandleMixin) {
  TableHead = [
    [
      {
        text: 'No',
      },
      {
        text: 'Source',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Username',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Role',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Reset',
      },
      {
        text: 'Log',
      },
    ],
  ];

  TableHeadResetSubPassLog = [
    [
      {
        displayName: 'securecode.no',
      },
      {
        displayName: 'securecode.operator',
      },
      {
        displayName: 'securecode.user',
      },
      {
        displayName: 'securecode.time',
      },
    ],
  ];

  SecureCodeInstance = getModule(SecureCodeModule, this.$store);

  searchText = '';

  editModel = {
    url: '',
    _id: '',
    partner: '',
    agent: '',
  };

  data = [];

  historyLog = []

  resetSubPassLogData = []

  historyPage = 1;

  isShowLogModal = false

  async fetchSecure() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.SecureCodeInstance.FetchSecureCode({ username: this.searchText });
    if (res.code) {
      this.checkError(res);
    }
    this.data = this.SecureCodeInstance.listSecureCode;
    this.GeneralInstance.toggleLoading(false);
  }

  async fetchLogReport(user) {
    this.GeneralInstance.toggleLoading(true);
    const selectedUsername = {
      username: user,
    };
    const { data, status } = await this.SecureCodeInstance
      .FecthResetSubPassLog(selectedUsername);
    const resData = data.map((item) => ({
      ...item,
      timestamp: moment(item.timestamp).add(-1, 'h').format('DD/MM/YYYY, hh:mm:ss a'),
    }));
    this.historyLog = resData.reverse();
    this.checkError(status);
    this.pageRenderHistory();
    this.isShowLogModal = true;
    this.GeneralInstance.toggleLoading(false);
  }

  pageRenderHistory() {
    this.resetSubPassLogData = this.historyLog
      .slice((this.historyPage - 1) * 5, (this.historyPage * 5));
  }

  handlePage(param) {
    this.historyPage += param;
    this.pageRenderHistory();
  }

  onSubmit() {
    this.fetchSecure();
  }

  handleEdit(item) {
    const {
      _id, url, partner, agent,
    } = item;
    this.editModel._id = _id;
    this.editModel.url = url;
    this.editModel.partner = partner;
    this.editModel.agent = agent;
  }

  handleCancel() {
    this.editModel = {
      url: '',
      _id: '',
      partner: '',
      agent: '',
    };
  }

  async handleSave() {
    const res = await this.SecureCodeInstance.ResetSecureCode({ username: this.searchText });
    this.checkError(res);
    await this.fetchSecure();
    this.handleCancel();
  }
}
